import { render, staticRenderFns } from "./productsV2.vue?vue&type=template&id=2da1deaa&scoped=true"
import script from "./productsV2.vue?vue&type=script&lang=ts"
export * from "./productsV2.vue?vue&type=script&lang=ts"
import style0 from "./productsV2.vue?vue&type=style&index=0&id=2da1deaa&prod&lang=css"
import style1 from "./productsV2.vue?vue&type=style&index=1&id=2da1deaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1deaa",
  null
  
)

export default component.exports